import React from 'react';
import QuillEditorWithImageResize from '../QuillEditorWithImageResize';

interface ScratchScoringRulesProps {
  value: string;
  onChange: (text: string, widths?: number[]) => void;
  questionId: string;
  imageWidths?: number[];
}

/**
 * Scratch 题目评分规则区
 * 使用富文本编辑器，支持图文混排
 *
 * 设计说明：
 * - QuillEditorWithImageResize 内部已是"非受控模式"，通过 key={questionId_targetField}
 *   处理题目切换；外层父组件通过 key={scoring-${id}-${editSessionId}} 处理"取消修改"场景。
 * - 这里【不能】再监听 value 变化去 setVersion 强制重建，否则：
 *   1) 用户拖拽图片缩放 → onChange(html, widths) → 父组件 updateDraft({scoringPoints, scoringPointsImageWidths})
 *   2) editDraft.scoringPoints 变化 → 本组件 value prop 变化 → useEffect 触发 setVersion
 *   3) QuillEditorWithImageResize 重新挂载 → 从 defaultValue 重新加载
 *      但此时 imageWidths prop 可能还是旧值（React 异步批处理），width% 注入用旧宽度
 *      → 图片缩放值丢失，无法持久化
 *   4) 更严重：每次输入文字也会触发 value 变化 → 每次输入都重建编辑器 → 无法正常编辑
 */
export default function ScratchScoringRules({
  value,
  onChange,
  questionId,
  imageWidths = []
}: ScratchScoringRulesProps) {
  return (
    <div>
      <QuillEditorWithImageResize
        key={`${questionId}-scoring`}
        value={value}
        onChange={onChange}
        questionId={`${questionId}-scoring`}
        targetField="scoringPoints"
        imageWidths={imageWidths}
        applyRealtimeScaling={true}
        placeholder="请输入评分规则，支持图文混排..."
      />
    </div>
  );
}
